import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { StreamService } from './stream.service';
import { TenantService } from './tenant.service';
import { map } from 'rxjs/operators';
import { forkJoin } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CatalogTopicGuard implements CanActivate {
    constructor(private streamService: StreamService, private tenantService: TenantService) { }

    canActivate = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        return forkJoin([
            this.streamService.getStream(route.params.topicId || route.parent.params.topicId),
            this.tenantService.getCurrentTenant()
        ])
        .pipe(
            map(([topic, tenant]) => {
                return (topic.tenantId && (topic.tenantId === tenant.id)) ? true : false;
            })
        );
    }
}
